export default "<ion-content class=\"ion-padding\">\n  <app-page-selector></app-page-selector>\n</ion-content>\n";